export const alertMessagesLifetime = 7000
export const tabularDataRowsOnPage = 20
